import React from "react";

export default function Good() {
  return (
    <g mask="url(#mask0)">
      <path
        d="M131.994 106.103C139.159 93.692 142.386 79.3972 141.247 65.1116C140.107 50.826 134.656 37.2234 125.614 26.1051L114.691 34.9876C121.934 43.8931 126.301 54.7884 127.213 66.2309C128.126 77.6733 125.541 89.123 119.802 99.0639L131.994 106.103Z"
        fill="#7D237D"
      />
      <path
        d="M126.093 26.7015C117.172 15.486 105.055 7.24477 91.3454 3.06916L87.2435 16.5363C98.2242 19.8809 107.93 26.4819 115.076 35.4653L126.093 26.7015Z"
        fill="#A83559"
      />
      <path
        d="M91.4163 3.0908C77.7116 -1.09916 63.0574 -1.02756 49.3942 3.29613L53.6416 16.7181C64.5855 13.255 76.3231 13.1976 87.3003 16.5537L91.4163 3.0908Z"
        fill="#FF5354"
      />
      <path
        d="M14.9951 27.1869C6.17212 38.4798 0.987382 52.1863 0.127458 66.4915L14.1801 67.3362C14.8689 55.8782 19.0217 44.8996 26.0888 35.8542L14.9951 27.1869Z"
        fill="#4FCBAD"
      />
      <path
        d="M0.172308 65.801C-0.827372 80.0971 2.53889 94.3596 9.82533 106.7L21.9479 99.5421C16.1116 89.6578 13.4153 78.2339 14.216 66.7831L0.172308 65.801Z"
        fill="#4BF0E6"
      />
      <path
        d="M49.4648 3.27384C35.7971 7.58323 23.7608 15.9425 14.9496 27.2446L26.1067 35.9428C33.1557 26.901 42.7848 20.2136 53.7189 16.7661L49.4648 3.27384Z"
        fill="#F0E65F"
      />
    </g>
  );
}
